import { Report } from "@/services/backend/htz/report/types/report";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/shared/components/ui/card";
import t from "@/lang/lang";
import { Photo } from "@/services/backend/htz/inspection/types/photo";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { AirHandlingUnitComponentName } from "@/services/backend/htz/ahu/components/air-handling-unit-data-designation";
import { useDocumentBlobLoadQuery } from "@/services/backend/filestorage/api/document-blob-api";
import { GSMDocumentKind } from "@/services/backend/documents/types/kind";
import { DocumentBlobKind } from "@bitory-gmbh/bsm";

export function PhotosComponent({ report }: { report: Report }) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>{t("Fotos")}</CardTitle>
        <CardDescription>{t("Fotos aus dem Arbeitsschein.")}</CardDescription>
      </CardHeader>
      <CardContent className="grid grid-cols-3 gap-4">
        {report.photos.map((photo) => (
          <PhotoComponent photo={photo} key={photo.id} report={report} />
        ))}
      </CardContent>
    </Card>
  );
}

function PhotoComponent({ photo, report }: { photo: Photo; report: Report }) {
  const {
    data: photoData,
    isLoading,
    error,
  } = useDocumentBlobLoadQuery({
    subdomain: "htz",
    documentId: report.id!,
    documentKind: GSMDocumentKind.Report,
    kind: DocumentBlobKind.Attachment,
    version: "",
    filename: photo.fileId!,
  });

  if (isLoading) {
    return <div>{t("Lade Foto...")}</div>;
  }

  if (error) {
    return <RTKQueryErrorAlert error={error} />;
  }

  return (
    <div className="space-y-3">
      <img src={photoData!.objectUrl} alt="Foto" />
      <div className="space-y-1 text-sm">
        <h3 className="leading-none font-medium">
          <AirHandlingUnitComponentName
            id={report.ahuDataId!}
            componentId={photo.componentId}
          />
        </h3>
        <p className="text-muted-foreground text-xs">{photo.comment}</p>
      </div>
    </div>
  );
}
